module.exports = __webpack_public_path__ + "img/icon-usuario.8ed7dfa7.svg";